export default [

    {
        path: '',
        name: 'artes-digitais',
        redirect: { name: 'artes-digitais-home' },
    },

    {
        path: 'home',
        name: 'artes-digitais-home',
        component: () => import('@/aplicacao/modulos/artes-digitais/_Home.vue'),
        meta: { autenticacao: true, permissao: 'ROLE__ARTES_DIGITAIS' },
    },

    {
        path: 'formulario/:id?',
        name: 'artes-digitais-formulario',
        component: () => import('@/aplicacao/modulos/artes-digitais/formulario/Formulario.vue'),
        meta: { autenticacao: true, permissao: 'ROLE__ARTES_DIGITAIS__SOLICITAR' },
    },

    {
        path: 'rascunhos',
        name: 'artes-digitais-rascunhos',
        component: () => import('@/aplicacao/modulos/artes-digitais/rascunhos/Rascunhos.vue'),
        meta: { autenticacao: true, permissao: 'ROLE__ARTES_DIGITAIS__SOLICITAR' },
    },

    {
        path: 'historico',
        name: 'artes-digitais-historico',
        component: () => import('@/aplicacao/modulos/artes-digitais/historico/Historico.vue'),
        meta: { autenticacao: true, permissao: 'ROLE__ARTES_DIGITAIS' },
    },

    {
        path: 'pendencias',
        name: 'artes-digitais-pendencias',
        component: () => import('@/aplicacao/modulos/artes-digitais/pendencias/Pendencias.vue'),
        meta: { autenticacao: true, permissao: 'ROLE__ARTES_DIGITAIS' },
    },

    {
        path: 'fluxo/:id',
        name: 'artes-digitais-fluxo',
        component: () => import('@/aplicacao/modulos/artes-digitais/fluxo/Fluxo.vue'),
        meta: { autenticacao: true, permissao: 'ROLE__ARTES_DIGITAIS' },
    },

    {
        path: 'artes-finalizadas',
        name: 'artes-digitais-artes-finalizadas',
        component: () => import('@/aplicacao/modulos/artes-digitais/artes-realizadas/ArtesRealizadas.vue'),
        meta: { autenticacao: true, permissao: 'ROLE__ARTES_DIGITAIS' },
    },

    {
        path: 'relatorios/geral',
        name: 'artes-digitais-relatorios-geral',
        component: () => import('@/aplicacao/modulos/artes-digitais/relatorios/Geral.vue'),
        meta: { autenticacao: true, permissao: 'ROLE__ARTES_DIGITAIS__RELATORIOS__GERAL' },
    },

]
